
import axios from "axios";
import { UserModel } from "types/models/dataAccess/User";
import axiosInstance from "../ApiConfig";

const accountId = 1468;

export const createFabmanMember = async (user: UserModel) => {

  let response = await axiosInstance({
    method: 'post',
    url: '/fabman-members',
    data: JSON.stringify(user)
  })
  // console.log(response.data);
  // console.log(response.status);
  return response.data;
}

export const getFabmanMembers = async (id?: number) => {
  axiosInstance.defaults.headers.common = { 'Authorization': `Bearer eyJhbGciOiJSUzI1NiIsImtpZCI6IjFiYjk2MDVjMzZlOThlMzAxMTdhNjk1MTc1NjkzODY4MzAyMDJiMmQiLCJ0eXAiOiJKV1QifQ.eyJpc3MiOiJodHRwczovL3NlY3VyZXRva2VuLmdvb2dsZS5jb20vZmFibGFiY29hIiwiYXVkIjoiZmFibGFiY29hIiwiYXV0aF90aW1lIjoxNjI3NTk5ODAyLCJ1c2VyX2lkIjoiekVlcHZQcG11dFhzcmdoRkFPdXpORnFZR0J2MiIsInN1YiI6InpFZXB2UHBtdXRYc3JnaEZBT3V6TkZxWUdCdjIiLCJpYXQiOjE2Mjc1OTk4MDIsImV4cCI6MTYyNzYwMzQwMiwiZW1haWwiOiJtZUBhcnBpdGEudXMiLCJlbWFpbF92ZXJpZmllZCI6ZmFsc2UsImZpcmViYXNlIjp7ImlkZW50aXRpZXMiOnsiZW1haWwiOlsibWVAYXJwaXRhLnVzIl19LCJzaWduX2luX3Byb3ZpZGVyIjoicGFzc3dvcmQifX0.RJDH2L5ek-pGAVApJ6hW8XNDpxnvr8UYxdp9CtdRjiJURZKzRav3TIeXcYAmCwYFLKXUmx-Fe2nwjQZKwIoh2qdGrt9j-_C1UoYL6_zUg9sr_bJS9Fi_iirKZlzs_G_T_8Ijo2k1Ezqd_TuiMwM_ZLP5iOo5pGQC6yqxvP7N2VlXoBogjyyBtQ7AyO0Bpx-ARwsG_LT2pY06dc-Tavp7FaWzReYh6a3OQ7jfMmlsFbLKjP1gVd7VS9rALZZKAwxB5CMXQ-_saN_4A33Tzs7GcvD_tTN4TW8H0XPoeGp0-pHxxerjPhntkZmt0N5zv3cv5BZd8DwZdvMs2nOECeHJkw` }

  let response = await axiosInstance({
    method: 'get',
    url: '/fabman-members',
  })
  // console.log(response.data);
  // console.log(response.status);
  return response.data;
}

export const getFabmanMemberPrivileges = async (id: string) => {
  axiosInstance.defaults.headers.common = { 'Authorization': `Bearer eyJhbGciOiJSUzI1NiIsImtpZCI6IjFiYjk2MDVjMzZlOThlMzAxMTdhNjk1MTc1NjkzODY4MzAyMDJiMmQiLCJ0eXAiOiJKV1QifQ.eyJpc3MiOiJodHRwczovL3NlY3VyZXRva2VuLmdvb2dsZS5jb20vZmFibGFiY29hIiwiYXVkIjoiZmFibGFiY29hIiwiYXV0aF90aW1lIjoxNjI3NTk5ODAyLCJ1c2VyX2lkIjoiekVlcHZQcG11dFhzcmdoRkFPdXpORnFZR0J2MiIsInN1YiI6InpFZXB2UHBtdXRYc3JnaEZBT3V6TkZxWUdCdjIiLCJpYXQiOjE2Mjc1OTk4MDIsImV4cCI6MTYyNzYwMzQwMiwiZW1haWwiOiJtZUBhcnBpdGEudXMiLCJlbWFpbF92ZXJpZmllZCI6ZmFsc2UsImZpcmViYXNlIjp7ImlkZW50aXRpZXMiOnsiZW1haWwiOlsibWVAYXJwaXRhLnVzIl19LCJzaWduX2luX3Byb3ZpZGVyIjoicGFzc3dvcmQifX0.RJDH2L5ek-pGAVApJ6hW8XNDpxnvr8UYxdp9CtdRjiJURZKzRav3TIeXcYAmCwYFLKXUmx-Fe2nwjQZKwIoh2qdGrt9j-_C1UoYL6_zUg9sr_bJS9Fi_iirKZlzs_G_T_8Ijo2k1Ezqd_TuiMwM_ZLP5iOo5pGQC6yqxvP7N2VlXoBogjyyBtQ7AyO0Bpx-ARwsG_LT2pY06dc-Tavp7FaWzReYh6a3OQ7jfMmlsFbLKjP1gVd7VS9rALZZKAwxB5CMXQ-_saN_4A33Tzs7GcvD_tTN4TW8H0XPoeGp0-pHxxerjPhntkZmt0N5zv3cv5BZd8DwZdvMs2nOECeHJkw` }

  let response = await axiosInstance({
    method: 'get',
    url: `/fabman-members/${id}/privileges`,
  })
  // console.log(response.data);
  // console.log(response.status);
  return response.data;
}

export const getFabmanMemberTrainedResources = async (id: string) => {
  axiosInstance.defaults.headers.common = { 'Authorization': `Bearer eyJhbGciOiJSUzI1NiIsImtpZCI6IjFiYjk2MDVjMzZlOThlMzAxMTdhNjk1MTc1NjkzODY4MzAyMDJiMmQiLCJ0eXAiOiJKV1QifQ.eyJpc3MiOiJodHRwczovL3NlY3VyZXRva2VuLmdvb2dsZS5jb20vZmFibGFiY29hIiwiYXVkIjoiZmFibGFiY29hIiwiYXV0aF90aW1lIjoxNjI3NTk5ODAyLCJ1c2VyX2lkIjoiekVlcHZQcG11dFhzcmdoRkFPdXpORnFZR0J2MiIsInN1YiI6InpFZXB2UHBtdXRYc3JnaEZBT3V6TkZxWUdCdjIiLCJpYXQiOjE2Mjc1OTk4MDIsImV4cCI6MTYyNzYwMzQwMiwiZW1haWwiOiJtZUBhcnBpdGEudXMiLCJlbWFpbF92ZXJpZmllZCI6ZmFsc2UsImZpcmViYXNlIjp7ImlkZW50aXRpZXMiOnsiZW1haWwiOlsibWVAYXJwaXRhLnVzIl19LCJzaWduX2luX3Byb3ZpZGVyIjoicGFzc3dvcmQifX0.RJDH2L5ek-pGAVApJ6hW8XNDpxnvr8UYxdp9CtdRjiJURZKzRav3TIeXcYAmCwYFLKXUmx-Fe2nwjQZKwIoh2qdGrt9j-_C1UoYL6_zUg9sr_bJS9Fi_iirKZlzs_G_T_8Ijo2k1Ezqd_TuiMwM_ZLP5iOo5pGQC6yqxvP7N2VlXoBogjyyBtQ7AyO0Bpx-ARwsG_LT2pY06dc-Tavp7FaWzReYh6a3OQ7jfMmlsFbLKjP1gVd7VS9rALZZKAwxB5CMXQ-_saN_4A33Tzs7GcvD_tTN4TW8H0XPoeGp0-pHxxerjPhntkZmt0N5zv3cv5BZd8DwZdvMs2nOECeHJkw` }

  let response = await axiosInstance({
    method: 'get',
    url: `/fabman-member/${id}/trained-resources`,
  })
  // console.log(response.data);
  // console.log(response.status);
  return response.data;
}

export const getFabmanResources = async () => {
  axiosInstance.defaults.headers.common = { 'Authorization': `Bearer eyJhbGciOiJSUzI1NiIsImtpZCI6IjFiYjk2MDVjMzZlOThlMzAxMTdhNjk1MTc1NjkzODY4MzAyMDJiMmQiLCJ0eXAiOiJKV1QifQ.eyJpc3MiOiJodHRwczovL3NlY3VyZXRva2VuLmdvb2dsZS5jb20vZmFibGFiY29hIiwiYXVkIjoiZmFibGFiY29hIiwiYXV0aF90aW1lIjoxNjI3NTk5ODAyLCJ1c2VyX2lkIjoiekVlcHZQcG11dFhzcmdoRkFPdXpORnFZR0J2MiIsInN1YiI6InpFZXB2UHBtdXRYc3JnaEZBT3V6TkZxWUdCdjIiLCJpYXQiOjE2Mjc1OTk4MDIsImV4cCI6MTYyNzYwMzQwMiwiZW1haWwiOiJtZUBhcnBpdGEudXMiLCJlbWFpbF92ZXJpZmllZCI6ZmFsc2UsImZpcmViYXNlIjp7ImlkZW50aXRpZXMiOnsiZW1haWwiOlsibWVAYXJwaXRhLnVzIl19LCJzaWduX2luX3Byb3ZpZGVyIjoicGFzc3dvcmQifX0.RJDH2L5ek-pGAVApJ6hW8XNDpxnvr8UYxdp9CtdRjiJURZKzRav3TIeXcYAmCwYFLKXUmx-Fe2nwjQZKwIoh2qdGrt9j-_C1UoYL6_zUg9sr_bJS9Fi_iirKZlzs_G_T_8Ijo2k1Ezqd_TuiMwM_ZLP5iOo5pGQC6yqxvP7N2VlXoBogjyyBtQ7AyO0Bpx-ARwsG_LT2pY06dc-Tavp7FaWzReYh6a3OQ7jfMmlsFbLKjP1gVd7VS9rALZZKAwxB5CMXQ-_saN_4A33Tzs7GcvD_tTN4TW8H0XPoeGp0-pHxxerjPhntkZmt0N5zv3cv5BZd8DwZdvMs2nOECeHJkw` }

  let response = await axiosInstance({
    method: 'get',
    url: '/fabman-resources',
  })
  // console.log(response.data);
  // console.log(response.status);
  return response.data;
}


export const getFabmanCourses = async () => {
  axiosInstance.defaults.headers.common = { 'Authorization': `Bearer eyJhbGciOiJSUzI1NiIsImtpZCI6IjFiYjk2MDVjMzZlOThlMzAxMTdhNjk1MTc1NjkzODY4MzAyMDJiMmQiLCJ0eXAiOiJKV1QifQ.eyJpc3MiOiJodHRwczovL3NlY3VyZXRva2VuLmdvb2dsZS5jb20vZmFibGFiY29hIiwiYXVkIjoiZmFibGFiY29hIiwiYXV0aF90aW1lIjoxNjI3NTk5ODAyLCJ1c2VyX2lkIjoiekVlcHZQcG11dFhzcmdoRkFPdXpORnFZR0J2MiIsInN1YiI6InpFZXB2UHBtdXRYc3JnaEZBT3V6TkZxWUdCdjIiLCJpYXQiOjE2Mjc1OTk4MDIsImV4cCI6MTYyNzYwMzQwMiwiZW1haWwiOiJtZUBhcnBpdGEudXMiLCJlbWFpbF92ZXJpZmllZCI6ZmFsc2UsImZpcmViYXNlIjp7ImlkZW50aXRpZXMiOnsiZW1haWwiOlsibWVAYXJwaXRhLnVzIl19LCJzaWduX2luX3Byb3ZpZGVyIjoicGFzc3dvcmQifX0.RJDH2L5ek-pGAVApJ6hW8XNDpxnvr8UYxdp9CtdRjiJURZKzRav3TIeXcYAmCwYFLKXUmx-Fe2nwjQZKwIoh2qdGrt9j-_C1UoYL6_zUg9sr_bJS9Fi_iirKZlzs_G_T_8Ijo2k1Ezqd_TuiMwM_ZLP5iOo5pGQC6yqxvP7N2VlXoBogjyyBtQ7AyO0Bpx-ARwsG_LT2pY06dc-Tavp7FaWzReYh6a3OQ7jfMmlsFbLKjP1gVd7VS9rALZZKAwxB5CMXQ-_saN_4A33Tzs7GcvD_tTN4TW8H0XPoeGp0-pHxxerjPhntkZmt0N5zv3cv5BZd8DwZdvMs2nOECeHJkw` }

  let response = await axiosInstance({
    method: 'get',
    url: '/fabman-courses',
  })
  // console.log(response.data);
  // console.log(response.status);
  return response.data;
}

export const addFabmanMemberTraining = async (memberTrainingObj: any) => {

  let response = await axiosInstance({
    method: 'post',
    url: '/fabman-member-training',
    data: memberTrainingObj
  })
  // console.log(response.data);
  // console.log(response.status);
  return response.data;
}

export const getFabmanBookings = async (params: any) => {

  let response = await axiosInstance({
    method: 'get',
    url: '/fabman-bookings',
    params: params
  })
  // console.log(response.data);
  // console.log(response.status);
  return response.data;
}

export const createBooking = async (bookingRequest: any) => {

  let response = await axiosInstance({
    method: 'post',
    url: '/fabman-bookings',
    data: JSON.stringify(bookingRequest)
  })
  // console.log(response.data);
  // console.log(response.status);
  return response.data;
}


export const cancelMachineBooking = async (id: string) => {

  let response = await axiosInstance({
    method: 'delete',
    url: `/fabman-bookings/${id}`,
  })
  // console.log(response.data);
  // console.log(response.status);
  return response.data;
}

export const getOpeningHours = async () => {
  axiosInstance.defaults.headers.common = { 'Authorization': `Bearer eyJhbGciOiJSUzI1NiIsImtpZCI6IjFiYjk2MDVjMzZlOThlMzAxMTdhNjk1MTc1NjkzODY4MzAyMDJiMmQiLCJ0eXAiOiJKV1QifQ.eyJpc3MiOiJodHRwczovL3NlY3VyZXRva2VuLmdvb2dsZS5jb20vZmFibGFiY29hIiwiYXVkIjoiZmFibGFiY29hIiwiYXV0aF90aW1lIjoxNjI3NTk5ODAyLCJ1c2VyX2lkIjoiekVlcHZQcG11dFhzcmdoRkFPdXpORnFZR0J2MiIsInN1YiI6InpFZXB2UHBtdXRYc3JnaEZBT3V6TkZxWUdCdjIiLCJpYXQiOjE2Mjc1OTk4MDIsImV4cCI6MTYyNzYwMzQwMiwiZW1haWwiOiJtZUBhcnBpdGEudXMiLCJlbWFpbF92ZXJpZmllZCI6ZmFsc2UsImZpcmViYXNlIjp7ImlkZW50aXRpZXMiOnsiZW1haWwiOlsibWVAYXJwaXRhLnVzIl19LCJzaWduX2luX3Byb3ZpZGVyIjoicGFzc3dvcmQifX0.RJDH2L5ek-pGAVApJ6hW8XNDpxnvr8UYxdp9CtdRjiJURZKzRav3TIeXcYAmCwYFLKXUmx-Fe2nwjQZKwIoh2qdGrt9j-_C1UoYL6_zUg9sr_bJS9Fi_iirKZlzs_G_T_8Ijo2k1Ezqd_TuiMwM_ZLP5iOo5pGQC6yqxvP7N2VlXoBogjyyBtQ7AyO0Bpx-ARwsG_LT2pY06dc-Tavp7FaWzReYh6a3OQ7jfMmlsFbLKjP1gVd7VS9rALZZKAwxB5CMXQ-_saN_4A33Tzs7GcvD_tTN4TW8H0XPoeGp0-pHxxerjPhntkZmt0N5zv3cv5BZd8DwZdvMs2nOECeHJkw` }

  let response = await axiosInstance({
    method: 'get',
    url: '/fabman-opening-hours',
  })
  // console.log(response.data);
  // console.log(response.status);
  return response.data;
}
